// Content-addressed case assets hosted in the overseas GCP media bucket.
const assetBase = 'https://media.dobidobi.ai/marketing/creative-workflow-20260914';

export const CREATIVE_CASE_MEDIA = {
  model: { src: `${assetBase}/model-76612c596555.webp`, width: 735, height: 985 },
  blouse: { src: `${assetBase}/blouse-27273716529c.webp`, width: 1024, height: 1360 },
  shorts: { src: `${assetBase}/shorts-c8b9a68e99ae.webp`, width: 1024, height: 1360 },
  sandals: { src: `${assetBase}/sandals-07d38feceac9.webp`, width: 563, height: 845 },
  bag: { src: `${assetBase}/bag-4cbe6cd4961e.webp`, width: 1067, height: 1600 },
  outfit: { src: `${assetBase}/outfit-a0a2f3dde8e5.webp`, width: 1195, height: 1600 },
  styleSeated: { src: `${assetBase}/styleSeated-cc1da90e8040.webp`, width: 1000, height: 1500 },
  styleSkipping: { src: `${assetBase}/styleSkipping-a89030f6f4e4.webp`, width: 1000, height: 1500 },
  styleStretching: { src: `${assetBase}/styleStretching-0f4d7a254729.webp`, width: 1000, height: 1500 },
  socks: { src: `${assetBase}/socks-8bcea1a85b38.webp`, width: 1067, height: 1600 },
  dress: { src: `${assetBase}/dress-9af04e3a74e4.webp`, width: 1067, height: 1600 },
  chair: { src: `${assetBase}/chair-0fba9684503d.webp`, width: 1200, height: 1600 },
  vase: { src: `${assetBase}/vase-4afea4e1b51c.webp`, width: 1200, height: 1600 },
  shoes: { src: `${assetBase}/shoes-92cddad9fc1d.webp`, width: 1200, height: 1600 },
  earrings: { src: `${assetBase}/earrings-48e95d1d13b1.webp`, width: 1200, height: 1600 },
  motion: { src: `${assetBase}/motion-48be5d52942f.mp4` },
} as const;
export type CreativeCaseImageKey = Exclude<keyof typeof CREATIVE_CASE_MEDIA, 'motion'>;
